export default "__VITE_ASSET__DSTiA_8q__"